import React from 'react';
import { HeaderContainer, TabItem, TabList, HeaderOptions, TabIcon } from './styles';

const FreecodePlayerHeader = React.forwardRef(
  ({ items, active, setActive, isDarkMode, isPopOut, setIsPopOut }, ref) => {
    return (
      <HeaderContainer ref={ref}>
        <TabList>
          {items.map((item, index) => (
            <TabItem
              id={item.tabId}
              key={index}
              active={index === active}
              isDarkMode={isDarkMode}
              onClick={() => setActive(index)}
            >
              {item.label}
            </TabItem>
          ))}
        </TabList>
        <HeaderOptions>
          <TabIcon
            icon={isPopOut ? 'fa fa-compress' : 'fa fa-expand'}
            onClick={() => setIsPopOut(!isPopOut)}
            isDarkMode={isDarkMode}
            title={'Toggle player overlay'}
          />
        </HeaderOptions>
      </HeaderContainer>
    );
  }
);

export default FreecodePlayerHeader;
